import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PolicyView from '../views/PolicyView.vue'
import OurAppView from "@/views/OurAppView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/privacy-verklaring',
    name: 'privacy-verklaring',
    component: PolicyView
  },
  {
    path: '/onze-app',
    name: 'onze-app',
    component: OurAppView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
